import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/GroupPhase.css";
import "../styles/AdminPanel.css"; // Neue Styles für AdminPanel Tabs & Karten
import PersonList from "./PersonList";
import PersonGroupList from "./PersonGroupList";
import TaskList from "./tasks/TaskList"; // Aufgabenliste integriert
import PlayerManagement from "./tournament/PlayerManagement";
import PushSendForm from "./PushSendForm";

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("personen");
  const [personenSubTab, setPersonenSubTab] = useState("liste");

  return (
    <div className="adminpanel-container">
      <div className="adminpanel-page-header">
        <div>
          <p className="adminpanel-eyebrow">Adminbereich</p>
          <h1 className="adminpanel-title">Verwaltung</h1>
          <p className="adminpanel-page-description">
            Personen, Gruppen und Aufgaben werden hier zentral gepflegt. Die Turnierverwaltung finden Sie
            jetzt direkt in der Hauptnavigation unter <strong>Turniere &gt; Verwalten</strong>.
          </p>
        </div>
        <div className="adminpanel-page-actions">
          <Link to="/tournaments/manage" className="adminpanel-link-button">
            Zur Turnierverwaltung
          </Link>
        </div>
      </div>

      <section className="adminpanel-card adminpanel-info-card">
        <h2>Navigation vereinfacht</h2>
        <p className="adminpanel-page-description">
          Die Turnierverwaltung ist nicht mehr als eigener Reiter im Adminbereich versteckt. So sind
          Turnierfunktionen dort erreichbar, wo Benutzer sie erwarten: im Menü <strong>Turniere</strong>.
        </p>
      </section>

      {/* Tab Navigation */}
      <div className="adminpanel-tabs" role="tablist">
        <button
          className={`adminpanel-tab ${activeTab === "personen" ? "active" : ""}`}
          onClick={() => setActiveTab("personen")}
          role="tab"
          aria-selected={activeTab === "personen"}
        >
          Personen
        </button>
        <button
          className={`adminpanel-tab ${activeTab === "aufgaben" ? "active" : ""}`}
          onClick={() => setActiveTab("aufgaben")}
          role="tab"
          aria-selected={activeTab === "aufgaben"}
        >
          Aufgaben
        </button>
        <button
          className={`adminpanel-tab ${activeTab === "benachrichtigungen" ? "active" : ""}`}
          onClick={() => setActiveTab("benachrichtigungen")}
          role="tab"
          aria-selected={activeTab === "benachrichtigungen"}
        >
          Benachrichtigungen
        </button>
      </div>


      {/* Bereich: Personen */}
      {activeTab === "personen" && (
        <div className="adminpanel-single">
          {/* Untertabs für Personen */}
          <div className="adminpanel-tabs" role="tablist" style={{ marginBottom: '20px' }}>
            <button
              className={`adminpanel-tab ${personenSubTab === "liste" ? "active" : ""}`}
              onClick={() => setPersonenSubTab("liste")}
              role="tab"
              aria-selected={personenSubTab === "liste"}
            >
              Personenliste
            </button>
            <button
              className={`adminpanel-tab ${personenSubTab === "gruppen" ? "active" : ""}`}
              onClick={() => setPersonenSubTab("gruppen")}
              role="tab"
              aria-selected={personenSubTab === "gruppen"}
            >
              Gruppen
            </button>
            <button
              className={`adminpanel-tab ${personenSubTab === "spielerpool" ? "active" : ""}`}
              onClick={() => setPersonenSubTab("spielerpool")}
              role="tab"
              aria-selected={personenSubTab === "spielerpool"}
            >
              Spielerpool
            </button>
          </div>
          
          {/* Inhalte der Untertabs */}
          {personenSubTab === "liste" && <PersonList />}
          {personenSubTab === "gruppen" && <PersonGroupList />}
          {personenSubTab === "spielerpool" && <PlayerManagement />}
        </div>
      )}

      {/* Bereich: Aufgaben */}
      {activeTab === "aufgaben" && (
        <div className="adminpanel-single">
          <TaskList />
        </div>
      )}

      {/* Bereich: Benachrichtigungen */}
      {activeTab === "benachrichtigungen" && (
        <div className="adminpanel-single">
          <PushSendForm />
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
